var _a;
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
const initReferencesNotes = () => {
    return new Swiper('.js-reference-items-swiper', {
        slidesPerView: 1,
        navigation: {
            nextEl: '.reference-button-next',
            prevEl: '.reference-button-prev',
        },
        pagination: {
            el: '.reference-pagination',
            dynamicBullets: true,
            dynamicMainBullets: 3,
            renderBullet(index, className) {
                return `<span class="${className}">${index + 1}</span>`;
            },
        },
        modules: [Navigation, Pagination],
    });
};
function getPageNumber(totalItemsPerPage, elementIndex) {
    let pageNumber = 0;
    if (elementIndex % totalItemsPerPage === 0) {
        pageNumber = elementIndex / totalItemsPerPage;
    }
    else {
        pageNumber = Math.floor(elementIndex / totalItemsPerPage) + 1;
    }
    return pageNumber - 1;
}
const initLinks = (ActiveSlider) => {
    const links = document.querySelectorAll('.js-note-ancher-link');
    links &&
        links.forEach((link) => {
            link.addEventListener('click', (event) => {
                const { target } = event;
                if (target instanceof HTMLElement && ActiveSlider) {
                    const matches = target.innerText.match(/\d+/);
                    const hits = matches ? parseInt(matches[0], 10) : 0;
                    const referenceItemsSwiper = document.querySelector('.js-reference-items-swiper');
                    if (referenceItemsSwiper) {
                        const windowHeight = window.innerHeight;
                        const elementTop = referenceItemsSwiper.getBoundingClientRect().top;
                        const totalItemsPerPage = 3;
                        const pageNumber = getPageNumber(totalItemsPerPage, hits);
                        if (ActiveSlider.slides.length > pageNumber) {
                            window.scrollBy({
                                top: elementTop - windowHeight / 3,
                                behavior: 'smooth',
                            });
                            ActiveSlider.slideTo(pageNumber);
                        }
                        else {
                            alert('Посилання не існує, воно було видалено або переміщено');
                        }
                    }
                }
            });
        });
};
document.addEventListener('DOMContentLoaded', function () {
    const slider = initReferencesNotes();
    console.log('slider', slider);
    initLinks(slider);
}, false);
if (window.acf) {
    (_a = window.acf) === null || _a === void 0 ? void 0 : _a.addAction('render_block_preview', initReferencesNotes);
}
